import { AccountEventItem } from '@monorepo/types';

export const enum EventColor {
  Green = 'green',
  Blue = 'blue',
  Red = 'red',
  Gray = 'gray',
}

export const eventColorMap: Record<EventColor, AccountEventItem[]> = {
  [EventColor.Green]: [AccountEventItem.Created, AccountEventItem.Target],
  [EventColor.Blue]: [],
  [EventColor.Red]: [
    AccountEventItem.Delete,
    AccountEventItem.DailyPause,
    AccountEventItem.DailyLoss,
    AccountEventItem.Termination,
    AccountEventItem.Expired,
  ],
  [EventColor.Gray]: [],
};
